import { useToastManager } from "@porsche-design-system/components-react"
import type { InteriorView } from "@slfinrtl/ui-bff-routes"
import { useContext, useState } from "react"
import { defineMessages, useIntl } from "react-intl"
import { commonMessages } from "src/common/messages/common.messages"
import { Modal } from "src/context/modal/Modal"
import { ModalContext } from "src/context/modal/ModalContext"
import type { ModalProps } from "src/context/modal/ModalProvider"
import type { OrderType } from "../OrderType"
import { SelectCatalogInteriorContainer } from "./catalog/SelectCatalogInteriorContainer"
import { CustomInteriorContainer } from "./custom/CustomInteriorContainer"

const messages = defineMessages({
	selectInterior: {
		defaultMessage: "Select interior",
		id: "colors.interior.selectInterior",
	},
})

export interface SelectInteriorModalProps {
	interior: InteriorView | undefined
	inventoryId: string
	orderType: OrderType
	setInterior: (interior: InteriorView) => void
}

type InteriorModalState = "catalog" | "custom"

export const SelectInteriorModal = ({
	id,
	modalProps: { interior, inventoryId, orderType, setInterior },
}: ModalProps<SelectInteriorModalProps>) => {
	const { formatMessage } = useIntl()
	const { hideModal } = useContext(ModalContext)
	const [state, setState] = useState<InteriorModalState>(!interior || interior.optionCode ? "catalog" : "custom")
	const { addMessage } = useToastManager()

	return (
		<Modal id={id} width="wide" heading={formatMessage(messages.selectInterior)}>
			{state === "catalog" ? (
				<SelectCatalogInteriorContainer
					orderType={orderType}
					inventoryId={inventoryId}
					currentInterior={interior}
					onInteriorSelected={(selectedInterior) => {
						hideModal(id)
						setInterior(selectedInterior)
						addMessage({
							state: "success",
							text: formatMessage(commonMessages.saveSuccess),
						})
					}}
					showCustomInteriorContainer={() => setState("custom")}
				/>
			) : (
				<CustomInteriorContainer
					inventoryId={inventoryId}
					currentInterior={interior}
					onInteriorCreated={(createdInterior) => {
						hideModal(id)
						setInterior(createdInterior)
						addMessage({
							state: "success",
							text: formatMessage(commonMessages.saveSuccess),
						})
					}}
					showCatalogInteriorContainer={() => setState("catalog")}
				/>
			)}
		</Modal>
	)
}
